const apiArr = [
    {
        name: "caseList",
        path: '/report_hall/case_list',
        method: "GET",
        desc: "案例报告和成果库列表",
    }, {
        name: "trialCase",
        path: '/report_hall/trial_case',
        method: "GET",
        desc: "试读案例报告，成果案例",
    }, {
        name: "caseDetail",
        path: '/report_hall/case_detail',
        method: "GET",
        desc: "查询学习案例，成果详情",
    }, {
        name: "studyList",
        path: '/report_hall/study_list',
        method: "GET",
        desc: "学习报告列表",
    }, {
        name: "trialStudy",
        path: '/report_hall/trial_study',
        method: "GET",
        desc: "试读学习报告",
    }, {
        name: "studyDetail",
        path: '/report_hall/study_detail',
        method: "GET",
        desc: "学习报告详情",
    }, {
        name: "queryLabel",
        path: '/report_hall/queryLabel',
        method: "POST",
        desc: "查询标签",
    }, {
        name: "login",
        path: '/report/login',
        method: "POST",
        desc: "登录",
    }, {
        name: "register",
        path: '/report/register',
        method: "POST",
        desc: "注册",
    }, {
        name: "resetPassword",
        path: '/report/reset_password',
        method: "POST",
        desc: "重置密码",
    }, {
        name: "changePassword",
        path: '/report/change_password',
        method: "POST",
        desc: "修改密码",
    }, {
        name: "checkCode",
        path: '/report/check_code',
        method: "POST",
        desc: "校验短信验证码",
    }, {
        name: "sendSms",
        path: '/report/send_sms',
        method: "POST",
        desc: "发送短信验证码",
    }, {
        name: "buyReport",
        path: '/report_hall/buy_report',
        method: "GET",
        desc: "我的报告",
    }, {
        name: "collectReport",
        path: '/report_hall/collect_report',
        method: "GET",
        desc: "我的收藏",
    }, {
        name: "setCollec",
        path: '/report_hall/set_collect',
        method: "POST",
        desc: "收藏/取消收藏",
    }, {
        name: "wxQrCode",
        path: '/wx_pay/qr_code',
        method: "POST",
        desc: "生成微信支付二维码",
    }, {
        name: "wxOrderPayStatus",
        path: '/wx_pay/order_pay_status',
        method: "POST",
        desc: "查询是否支付成功",
    }, {
        name: "readCase",
        path: '/report_hall/read_case',
        method: "GET",
        desc: "阅读案例报告、成果报告",
    }, {
        name: "readStudy",
        path: '/report_hall/read_study',
        method: "GET",
        desc: "阅读学习报告",
    }
]

export default apiArr;



// WEBPACK FOOTER //
// ./src/config/api.js